module.exports = __webpack_public_path__ + "img/as.e46b65c0.svg";